export enum CompileStatus {
    WAITING = 0,
    COMPILING = 1,
    COMPLETE = 2,
}